module.exports = __webpack_public_path__ + "static/img/aid.d8932c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aid.svg
// module id = 6XFv
// module chunks = 1